import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const Service = {
  // 基础数据
  baseInfo: async () => {
    const data: IResult | null = await apiGet('/mg/base/default_market_area');
    if (!data) return null;
    return (data as IResult).result;
  },
  // base/info 接口
  base: async () => {
    const res: IResult | null = await apiGet('/mg/base/info?type=smart');
    if (isEmpty(res) || isEmpty(res?.result)) return null;
    return res?.result;
  },
  // 获取用户信息
  user: async () => {
    const data: IResult | null = await apiGet('/mg/users');
    if (!data) return null;
    return (data as IResult).result;
  },
  // 退出登录
  logout: async () => {
    const data: IResult | null = await apiGet('/mg/users/logout');
    if (!data) return [];
    return (data as IResult);
  },
  // 客户评价
  comments: async () => {
    const data: IResult | null = await apiGet('/mg/customer_comments');
    if (!data) return [];
    return (data as IResult).result;
  },
  // 搜索框下的热门职位
  subJob: async () => {
    const data: IResult | null = await apiGet('/mg/payrolls/market/hot_jobs');
    if (!data) return [];
    return (data as IResult).result;
  },
  // 开通企业套餐
  application: async (params: any) => {
    const data: IResult | null = await apiPost('/mg/custom/reports/applications', params);
    if (!data) return [];
    return (data as IResult);
  },
  // 让他联系我
  onService: async () => {
    const token = Cookies.get('access_token') || '';
    const param = {
      PASSBY: true,
      access_token: token,
    };
    const data: IResult | null = await apiPost('/mg/users/contact_sale', param);
    if (!data) return [];
    return (data as IResult);
  },

  // 换肤配置
  getSkin: async (val?: string) => {
    const data: IResult | null = await apiGet('/mg/skin/config', {
      PASSBY: true,
      key: val,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  // 获取行业，城市，企业规模，企业性质
  info: async () => {
    const res: any = await apiGet('/mg/base/info?type=smart');
    if (res.code !== 0 || isEmpty(res.result)) return null;
    return res.result;
  },
  postActivity: async (uuid: string) => {
    await apiPost(`/mg/users/activity/${uuid}/visitor`, {});
  },
  marketArea: async (param: any) => {
    const data: IResult | null = await apiGet('/mg/market/area', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  industryDetail: async (code: number | string) => {
    const data: IResult | null = await apiGet(`/mg/market/industry_detail/statistics?industry=${code}`);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 查询次数
  getQueryNum: async (params: any) => {
    const data: IResult | null = await apiPost(`/mg/market/consume_chances?access_token=${params.access_token}`, { count: params.count });
    if (!data) return [];
    return (data as IResult);
  },
  // 获取剩余查询次数
  getChances: async (params: any) => {
    const data: IResult | null = await apiGet(`/mg/market/chances?access_token=${params.access_token}`, {});
    if (!data) return [];
    return (data as IResult);
  },
  // 导出PDF记录
  exportLog: async (token: any, module: string) => {
    const data: IResult | null = await apiPost(`/mg/pdf_log?access_token=${token}`, {
      module: module,
    });
    if (!data) return [];
    return (data as IResult);
  },
  // 获取模块更新时间（对标企业/人力核心指标/人效配置，PG 直查）
  updateTime: async () => {
    const data: IResult | null =
      await apiGet('/mg/rival/module/update_time');
    if (!data) return [];
    const result = (data as IResult).result;
    if (result) {
      // 兼容下游历史字段名
      if (result.hrIndicator) result.HRIndicator = result.hrIndicator; // top.ts / hot-job 用 HRIndicator
      if (result.humanEfficiency) result.efficiency = result.humanEfficiency; // effect 用 efficiency
    }
    return result;
  },
};

export default Service;
